var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconContract(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 22",
    style: {
      enableBackground: "new 0 0 18 22"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#004FFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.1,3.9l-3.3-3.3C13.4,0.3,12.9,0,12.4,0c0,0,0,0,0,0H2.3c-1.1,0-2,0.9-2,2v17.9c0,1.1,0.9,2,2,2h13.3 c1.1,0,2-0.9,2-2V5.3C17.7,4.8,17.4,4.3,17.1,3.9z M13.7,2.8L14.9,4h-1.2V2.8z M15.7,20.3H2.3C2.1,20.3,2,20.2,2,20V2.1 c0-0.2,0.2-0.4,0.4-0.4h9.7v3.1c0,0.4,0.4,0.8,0.8,0.8H16L16,20C16,20.2,15.9,20.3,15.7,20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7,17.8C7,17.8,7,17.8,7,17.8H3.4c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6c0,0,0,0,0,0H7 c0.3,0,0.6-0.3,0.6-0.6C7.6,18,7.4,17.8,7,17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.4,15.3h7.3c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6H3.4c-0.3,0-0.6,0.3-0.6,0.6 C2.8,15,3.1,15.3,3.4,15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.6,10.4H3.4c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6h11.2c0.3,0,0.6-0.3,0.6-0.6 C15.2,10.7,14.9,10.4,14.6,10.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.6,6.7H3.4C3.1,6.7,2.8,7,2.8,7.3l0,0c0,0.3,0.3,0.6,0.6,0.6h11.2c0.3,0,0.6-0.3,0.6-0.6 C15.2,7,14.9,6.7,14.6,6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.4,4.2h4.2c0.3,0,0.6-0.3,0.6-0.6S7.9,3.1,7.6,3.1H3.4c-0.3,0-0.6,0.3-0.6,0.6S3.1,4.2,3.4,4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.8,14.6C13.8,14.6,13.8,14.6,13.8,14.6l-3.2,3.2l-1.5-1.5c-0.2-0.2-0.6-0.2-0.8,0s-0.2,0.6,0,0.8l1.9,1.9 c0.1,0.1,0.3,0.2,0.4,0.2c0.2,0,0.3-0.1,0.4-0.2l3.6-3.6c0.2-0.2,0.2-0.6,0-0.8C14.4,14.4,14.1,14.4,13.8,14.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContract);
export default __webpack_public_path__ + "static/media/icon_contract.f12ed85b030739281584d1b740b06e75.svg";
export { ForwardRef as ReactComponent };